import React from "react";
import styles from "./skeleton.css";

const UserLocationSelectorSkeleton = () => {
    const NUM_CARDS = 3;
    return (
        <div styleName={"styles.changeLocationDropdown"}>
            <div styleName={"styles.skeletonLine styles.headingLine"} />
            <div styleName={"styles.searchContainer"}>
                <div styleName={"styles.skeletonBox styles.searchSkeleton"} />
            </div>
            <div styleName={"styles.skeletonLine styles.subtitleLine"} />
            {Array.from({ length: NUM_CARDS }, (_, i) => (
                <div styleName={"styles.cityWrapper"} key={i}>
                    <div styleName={"styles.skeletonBox styles.cityCard"} />
                    <div styleName={"styles.gradient"}>
                        <div styleName={"styles.skeletonLine styles.cityTitleLine"} />
                        <div styleName={"styles.skeletonLine styles.cityCountLine"} />
                    </div>
                </div>
            ))}
        </div>
    );
};

export default UserLocationSelectorSkeleton;
